$(document).ready(function () {
  const gridMode = localStorage.getItem("gridMode");
  if (gridMode === "change-2col") {
    $(".grid-display").addClass("change-2col");
  }

  $(document).on('click', '.change-grid', function () {
    $(".grid-display").toggleClass("change-2col");

    if ($(".grid-display").hasClass("change-2col")) {
      localStorage.setItem("gridMode", "change-2col");
    } else {
      localStorage.removeItem("gridMode");
    }
  });

  // 追加グロナビ
  $('.have-child').on('click', function () {
    let $this = $(this);
    let activeHaveChild = $('.have-child.active');
    let childList = $this.find('.child-list');

    $this.toggleClass('active');

    if (activeHaveChild && activeHaveChild[0] !== $this[0]) {
      activeHaveChild.removeClass('active');
    }

    $('.have-child').not($this).find('.child-list').removeClass('active');

    childList.toggleClass('active');
  });
});

document.addEventListener('DOMContentLoaded', function() {
  function forceStyles() {
    if (window.innerWidth <= 768) {
      // ① 【超重要】窓からはみ出た「チラ見せ部分」を強制的に見えなくする（切り落とす）
      var viewports = document.querySelectorAll('.featured-collection .carousel__viewport, .featured-collection .flickity-viewport');
      viewports.forEach(function(vp) {
        vp.style.setProperty('overflow', 'hidden', 'important');
      });

      // ② レールの隙間ゼロにする
      var tracks = document.querySelectorAll('.featured-collection .carousel__track');
      tracks.forEach(function(track) {
        track.style.setProperty('gap', '0', 'important');
      });

      // ③ スライドを「絶対に」3等分にする
      var slides = document.querySelectorAll('.featured-collection .carousel__slide');
      slides.forEach(function(slide) {
        slide.style.setProperty('width', '33.3333%', 'important');
        slide.style.setProperty('flex', '0 0 33.3333%', 'important'); 
        slide.style.setProperty('margin', '0', 'important'); 
        slide.style.setProperty('padding-left', '4px', 'important'); 
        slide.style.setProperty('padding-right', '4px', 'important'); 
        slide.style.setProperty('box-sizing', 'border-box', 'important'); 
        slide.style.setProperty('scroll-snap-align', 'start', 'important'); 
      });

      // ④ テキストを強制的に改行＆2行で省略する処理
      var titles = document.querySelectorAll('.featured-collection .product-item__details a');
      titles.forEach(function(title) {
        title.style.setProperty('display', '-webkit-box', 'important');
        title.style.setProperty('-webkit-box-orient', 'vertical', 'important');
        title.style.setProperty('-webkit-line-clamp', '2', 'important');
        title.style.setProperty('overflow', 'hidden', 'important');
        title.style.setProperty('white-space', 'normal', 'important');
        title.style.setProperty('word-break', 'break-all', 'important');
      });

      // ⑤ 矢印をご指定の bottom: 298.649px に固定する
      var arrows = document.querySelectorAll('.featured-collection .carousel__button, .featured-collection button[class*="prev"], .featured-collection button[class*="next"], .featured-collection .flickity-prev-next-button');
      arrows.forEach(function(arrow) {
        arrow.style.setProperty('top', 'auto', 'important'); 
        arrow.style.setProperty('bottom', '81%', 'important'); 
      });

      window.dispatchEvent(new Event('resize'));
    }

    // ⑥ スイッチャーの z-index を変更する処理
    var switchers = document.querySelectorAll('.lsn-switcher');
    switchers.forEach(function(switcher) {
      switcher.style.setProperty('z-index', '350', 'important');
    });
  }

  // 時間差で実行して確実に上書きする
  setTimeout(forceStyles, 500);
  setTimeout(forceStyles, 1500);
  setTimeout(forceStyles, 3000);
});

document.addEventListener('click', function(e) {
    // ※クラス名は実際のLorenzaのコードに合わせて変更します
    if (e.target.closest('.product-thumbnails__item-link')) {
      const mainImage = document.querySelector('.product__media');
      if (mainImage) {
        // ▼ ここで「もう少し上」の距離を調整します！（単位はpx）
        // ヘッダーの高さや、空けたい余白に合わせて数字を増やしたり減らしたりしてください。
        const offset = 100; 

        // 要素の現在の位置 ＋ 現在のスクロール量 － ズラしたい距離（offset）
        const targetPosition = mainImage.getBoundingClientRect().top + window.scrollY - offset;

        // スムーズに計算した位置へスクロール
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    }
  });
  
// ==========================================
// Instafeedをスマホで4列にする処理
// ==========================================
document.addEventListener('DOMContentLoaded', function() {
  function fixInstafeedLayout() {
    // 画面幅が768px（スマホサイズ）以下の時だけ実行
    if (window.innerWidth <= 768) {
      // ① 全体の枠を4列にする処理
      var instaFeeds = document.querySelectorAll('.instafeed-new-layout-wrapper');
      instaFeeds.forEach(function(feed) {
        feed.style.setProperty('grid-template-columns', 'repeat(4, 1fr)', 'important');
      });

      // ② 【修正】各画像のサイズと縦横比（4:5）を整える処理
      var instaItems = document.querySelectorAll('.instafeed-new-layout-item');
      instaItems.forEach(function(item) {
        item.style.setProperty('width', '100%', 'important');
        item.style.setProperty('height', 'auto', 'important');
        item.style.setProperty('aspect-ratio', '4 / 5', 'important');
      });
    }
  }

  // 外部アプリは画面に表示されるまでラグがあるため、
  // 1秒後、3秒後、5秒後と時間差で念入りにスタイルをねじ込みます
  setTimeout(fixInstafeedLayout, 1000);
  setTimeout(fixInstafeedLayout, 3000);
  setTimeout(fixInstafeedLayout, 5000);
});

document.addEventListener('DOMContentLoaded', function() {
  // ボタンを縮小する処理をまとめた関数
  function shrinkEasyPointsButton() {
    const epButton = document.querySelector('.epwa-container button');
    
    if (epButton) {
      // まだ小さくなっていない（またはリセットされた）場合のみ実行
      if (epButton.style.transform !== 'scale(0.8)') {
        epButton.style.setProperty('transform', 'scale(0.8)', 'important');
        epButton.style.setProperty('transform-origin', 'bottom right', 'important');
      }
    }
  }

  // 初回チェック
  shrinkEasyPointsButton();

  // 監視カメラ（MutationObserver）の設置
  const observer = new MutationObserver(function(mutations) {
    // 画面に何か変化（ポイント画面が開いた、閉じた等）があったら即座に縮小処理を実行
    shrinkEasyPointsButton();
  });

  // ページ全体（body）を対象に、24時間監視スタート
  observer.observe(document.body, {
    childList: true,      // 新しい要素が追加・削除された時
    subtree: true,        // 孫要素の深いところまで
    attributes: true,     // styleなどの属性が変更された時
    attributeFilter: ['style', 'class'] // 特にstyleやclassが変わった瞬間に反応
  });
});


document.addEventListener('DOMContentLoaded', function() {
  // =====================================================================
  // 【お問い合わせ欄のテキスト一括削除】
  // 商品管理画面の「商品説明文（Body HTML）」に直書きされてしまっている
  // 特定の注意書きテキストを、画面表示時に改行ごと綺麗に削除するための処理
  // =====================================================================
  
  // 消したい文字列を定義
  const targetText = "※商品名、または商品番号（article number）を必ずご入力いただきお問い合わせください。";
  
  // お問い合わせ欄のテキストが入っているクラス（.accordion__text）を取得
  const accordionTexts = document.querySelectorAll('.accordion__text');
  
  accordionTexts.forEach(function(el) {
    // 要素の中に消したい文字列が含まれているかチェック
    if (el.innerHTML.includes(targetText)) {
      // 直前の <br> ごと消して、余白が残らないように綺麗に削除（空文字に置換）
      el.innerHTML = el.innerHTML.replace('<br>' + targetText, '').replace(targetText, '');
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // =====================================================================
  // 【ポイントページの★アイコン非表示】
  // アプリのウィジェットは画面描画の少し後に遅れて出現するため、
  // setIntervalを使って要素が現れるのを待ってから非表示にします。
  // =====================================================================

  const hideStarInterval = setInterval(function() {
    // スクショから判明したクラス名を使って、★のSVGをピンポイントで狙い撃ち
    const starSvg = document.querySelector('.ep-mini-widget__header svg');

    // もしSVGが画面に出現したら
    if (starSvg) {
      starSvg.style.display = 'none'; // アプリの動作エラーを防ぐため、完全削除ではなく「非表示」にする
      clearInterval(hideStarInterval); // 目的を達成したらパトロール（監視）を終了
    }
  }, 300); // 0.3秒ごとにチェック

  // 念のため、10秒探しても見つからない（別のページなど）場合はパトロールを終了する
  setTimeout(function() {
    clearInterval(hideStarInterval);
  }, 10000);
});


document.addEventListener('DOMContentLoaded', function() {
  
  // ドロワー内のログインボタン（リモコン）が押された時
  document.addEventListener('click', function(e) {
    const drawerLoginBtn = e.target.closest('.custom-drawer-login-btn');
    
    if (drawerLoginBtn) {
      e.preventDefault(); // そのままページ移動するのを防ぐ
      
      // 1. まずはドロワーメニューを完全に閉じる
      const drawerCloseBtn = document.querySelector('.drawer-menu__close');
      if (drawerCloseBtn) {
        drawerCloseBtn.click();
      }
      
      // 2. ドロワーが閉じてセキュリティが解除されるのを待ってから（0.3秒後）、
      // ヘッダーにある「本物のHowdyボタン」を裏側で自動クリックする！
      setTimeout(function() {
        const headerLoginBtn = document.querySelector('.howdy-register-original-trigger-btn');
        if (headerLoginBtn) {
          headerLoginBtn.click();
        }
      }, 300); // ※もし上手くいかない場合は、この 300 を 500 などに増やしてみてください
    }
  });

});